import styled, { css } from "styled-components";
import { SearchOutlined } from "@ant-design/icons";

type FilterIconProps = {
  $filtered?: boolean;
};

export const FilterIcon = styled(SearchOutlined)<FilterIconProps>`
  ${({ $filtered }) =>
    $filtered &&
    css`
      color: ${({ theme }) => theme.colors.blueDianne};
    `};
`;
